import { cn } from '@/lib/utils'

type TextShimmerProps = {
  children: string
  className?: string
  duration?: number
}

/**
 * Cursor-style shimmer for transient agent narration (thinking_start / round_start).
 */
export function TextShimmer({ children, className, duration = 2 }: TextShimmerProps) {
  return (
    <span
      className={cn(
        'inline-block bg-gradient-to-r from-muted-foreground/35 via-foreground/75 to-muted-foreground/35',
        'bg-[length:200%_100%] bg-clip-text text-transparent animate-text-shimmer',
        className,
      )}
      style={{ animationDuration: `${duration}s` }}
    >
      {children}
    </span>
  )
}
